import React from "react";
import styles from "./Informer.module.scss";

export type InformerProps = {
  icon?: any;
  title: string;
  text?: string;
  button?: {
    callback: (feedback: any) => Promise<void>;
    text: string;
  };
};

// eslint-disable-next-line
const Informer: React.FC<InformerProps> = ({ icon, title, text, button }) => (
  <div className={styles.Wrapper}>
    {icon}
    <h1>{title}</h1>
    <p>{text}</p>
    {/* eslint-disable-next-line */}
    {button && <button onClick={button.callback}>{button.text}</button>}
  </div>
);

export default Informer;
